var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[(_vm.loaded && _vm.chartData)?_c('Doughnut',{ref:"chart",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.options,"styles":_vm.styles}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }